/* RESPONSIBLE TEAM: team-frontend-tech */
export const USER_ROLE_PREDICATE = {
  type: 'role',
  attribute: 'role',
  comparison: 'eq',
  value: 'user_role'
};
export const LEAD_ROLE_PREDICATE = {
  type: 'role',
  attribute: 'role',
  comparison: 'eq',
  value: 'contact_role'
};
export const VISITOR_ROLE_PREDICATE = {
  type: 'role',
  attribute: 'role',
  comparison: 'eq',
  value: 'visitor_role'
};
export const VAM_ROLE_PREDICATE = {
  type: 'role',
  attribute: 'role',
  comparison: 'ne',
  value: 'user_role'
};